<template>
  <div class="m-popup-ad-wrap">
    <a
      class="m-popup-ad x-link-active"
      :href="href"
      @click="handleClick"
    >
      <img
        :src="image"
        :alt="text"
        fetchpriority="high"
      >
    </a>

    <button
      class="m-pop-close-btn x-link-active"
      @click="handleClose"
    >
      <svg width="40" height="40" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0zm0 998.4C243.2 998.4 25.6 780.8 25.6 512S243.2 25.6 512 25.6 998.4 243.2 998.4 512 780.8 998.4 512 998.4z"/><path d="M706.56 296.96L512 494.08 317.44 296.96l-20.48 20.48L494.08 512 296.96 706.56l20.48 20.48L512 529.92l194.56 197.12 20.48-20.48L529.92 512l197.12-194.56z" /></svg>
    </button>
  </div>
</template>

<script>
import { getLocalAdReqBody } from 'wap/common/api'
import modalHelper from '@ms/utils/scroll-fixed'

export default {
  name: 'PopupAd',
  props: {
    href: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  mounted() {
    modalHelper.afterOpen()
    window.mstrace('Popup_AdCount')
  },
  deactivated() {
    modalHelper.beforeClose()
  },
  beforeDestroy() {
    modalHelper.beforeClose()
  },
  methods: {
    record() {
      let { oldImageData = [] } = getLocalAdReqBody('POPUP_AD')
      const image = this.image
      const index = oldImageData.findIndex((x) => x.image === image)
      if (index === -1) {
        oldImageData.unshift({ image, date: Date.now() })
      } else {
        oldImageData[index] = { image, date: Date.now() }
      }
      oldImageData = oldImageData.slice(0, 3)
      window.localStorage.setItem('POPUP_AD', JSON.stringify(oldImageData))
    },
    handleClick() {
      if (!this.href) {
        // 没配 href 就不能点击
        return
      }
      this.record()
      window.mstrace('Popup_AdCheck')
      location.href = this.href
    },
    handleClose() {
      modalHelper.beforeClose()
      this.record()
      window.mstrace('Popup_AdClose')
      this.$emit('close')
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.m-popup-ad-wrap {
  position: relative;

  .m-pop-close-btn {
    position: absolute;
    bottom: -60px;
    left: 50%;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    transform: translateX(-50%);

    svg {
      fill: #939393;
    }
  }

  .m-popup-ad {
    display: block;
    width: auto;
    margin: 0 auto;

    img {
      display: block;
      max-width: 80vw;
      max-height: 70vh;
      margin: 0 auto;
      aspect-ratio: 3/4;
    }
  }
}

</style>
